import { NodeResultAbstract } from '@/utils/measurements/node-results/node-result.abstract';
import { ValueItem } from '@/services/api.types';

type BloodPressureResultValue = {
  diastolic: number;
  systolic: number;
  completed_time: number;
};

export class BloodPressureResultClass extends NodeResultAbstract {
  getValue(key: 'diastolic' | 'systolic') {
    const found = this.getFirstValueChild<BloodPressureResultValue>();
    return found[key] ?? undefined;
  }

  getValues(): number[] | string[] {
    const values = this.getAllValueChildren<BloodPressureResultValue>();
    if (values) {
      return values.map(v => `${v['systolic']}/${v['diastolic']}`);
    } else {
      return [];
    }
  }

  getMeasurementValues<BloodPressureResultValue>(): Array<
    BloodPressureResultValue & ValueItem
  > {
    const values = this.getAllValueChildren<BloodPressureResultValue>();
    if (values) {
      return values.map((v: BloodPressureResultValue & ValueItem) => ({
        value: `${v['systolic']}/${v['diastolic']}`,
        completed_time: v.completed_time,
      })) as (BloodPressureResultValue & ValueItem)[];
    } else {
      return [];
    }
  }

  toString(): string {
    return `${this.getValue('systolic')}/${this.getValue('diastolic')}`;
  }
}
